const MyNetworkIconSVG = ({ className }) => (
    <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.5 7L17 10.5M7 13.5L10.5 17M10.5 7L7 10.5M17 13.5L13.5 17"
            stroke="currentColor"
            strokeLinecap="round"
        />
        <path
            d="M12 7.5C13.1046 7.5 14 6.60457 14 5.5C14 4.39543 13.1046 3.5 12 3.5C10.8954 3.5 10 4.39543 10 5.5C10 6.60457 10.8954 7.5 12 7.5Z"
            stroke="currentColor"
        />
        <path
            d="M12 20.5C13.1046 20.5 14 19.6046 14 18.5C14 17.3954 13.1046 16.5 12 16.5C10.8954 16.5 10 17.3954 10 18.5C10 19.6046 10.8954 20.5 12 20.5Z"
            stroke="currentColor"
        />
        <path
            d="M5.5 14C6.60457 14 7.5 13.1046 7.5 12C7.5 10.8954 6.60457 10 5.5 10C4.39543 10 3.5 10.8954 3.5 12C3.5 13.1046 4.39543 14 5.5 14Z"
            stroke="currentColor"
        />
        <path
            d="M18.5 14C19.6046 14 20.5 13.1046 20.5 12C20.5 10.8954 19.6046 10 18.5 10C17.3954 10 16.5 10.8954 16.5 12C16.5 13.1046 17.3954 14 18.5 14Z"
            stroke="currentColor"
        />
        <path
            d="M5.5 12.5C5.77614 12.5 6 12.2761 6 12C6 11.7239 5.77614 11.5 5.5 11.5C5.22386 11.5 5 11.7239 5 12C5 12.2761 5.22386 12.5 5.5 12.5Z"
            stroke="currentColor"
        />
    </svg>
);

export default MyNetworkIconSVG;
